import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PaySupportIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21 9.75H20.25V9C20.25 4.45 16.55 0.75 12 0.75C7.45 0.75 3.75 4.45 3.75 9V9.75H3C1.48 9.75 0.25 10.98 0.25 12.5V16.5C0.25 18.02 1.48 19.25 3 19.25H3.46C3.81 20.89 5.26 22.13 7 22.13H9.5C9.75 22.72 10.32 23.13 11 23.13C11.9 23.13 12.62 22.4 12.62 21.51C12.62 20.62 11.89 19.89 11 19.89C10.33 19.89 9.75 20.3 9.5 20.89H7C5.95 20.89 5.07 20.21 4.76 19.27H6C6.41 19.27 6.75 18.93 6.75 18.52V10.52C6.75 10.11 6.41 9.77 6 9.77H5.25V9.02C5.25 5.3 8.28 2.27 12 2.27C15.72 2.27 18.75 5.3 18.75 9.02V9.77H18C17.59 9.77 17.25 10.11 17.25 10.52V18.52C17.25 18.93 17.59 19.27 18 19.27H21C22.52 19.27 23.75 18.04 23.75 16.52V12.52C23.75 11 22.52 9.77 21 9.77V9.75ZM5.25 17.75H3C2.31 17.75 1.75 17.19 1.75 16.5V12.5C1.75 11.81 2.31 11.25 3 11.25H5.25V17.75ZM22.25 16.5C22.25 17.19 21.69 17.75 21 17.75H18.75V11.25H21C21.69 11.25 22.25 11.81 22.25 12.5V16.5Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PaySupportIcon.displayName = 'PaySupportIcon';
